import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone, Clock } from 'lucide-react';
import { useLanguage } from '../translations/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#2e5453] text-[#96ba1e] border-t border-[#3d6a68]">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Children Planet" 
                className="h-20 md:h-24 w-auto object-contain"
              />
            </div>
            <p className="text-[#c4d88f] text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-[#3d6a68] hover:bg-[#96ba1e] rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook className="w-4 h-4 text-[#96ba1e] hover:text-[#2e5453]" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-[#3d6a68] hover:bg-[#96ba1e] rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram className="w-4 h-4 text-[#96ba1e] hover:text-[#2e5453]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#96ba1e]">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2 text-[#c4d88f]">
              <li>
                <Link to="/packages" className="hover:text-[#96ba1e] transition-colors">
                  {t('footer.partyPackages')}
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-[#96ba1e] transition-colors">
                  {t('nav.gallery')}
                </Link>
              </li>
              <li>
                <Link to="/booking" className="hover:text-[#96ba1e] transition-colors">
                  {t('footer.bookAParty')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#96ba1e]">{t('footer.support')}</h3>
            <ul className="space-y-2 text-[#c4d88f]">
              <li>
                <Link to="/contact" className="hover:text-[#96ba1e] transition-colors">
                  {t('footer.contactUs')}
                </Link>
              </li>
              <li>
                <Link to="/contract" className="hover:text-[#96ba1e] transition-colors">
                  {t('footer.contractPayment')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-[#96ba1e]">{t('footer.visitUs')}</h3>
            <ul className="space-y-3 text-[#c4d88f] text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-[#96ba1e] flex-shrink-0 mt-0.5" />
                <span>{t('footer.address') || 'Burgas, Bulgaria'}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-[#96ba1e]" />
                <span>+359 XXX XXX XXX</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-[#96ba1e]" />
                <span>myinferno@gmail.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <Clock className="w-5 h-5 text-[#96ba1e]" />
                <span>{t('footer.workingHours') || '12:00 - 22:00 (incl. weekends)'}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#3d6a68] mt-8 pt-6 text-center text-[#c4d88f] text-sm">
          <p>&copy; 2025 Children Planet. {t('footer.allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
